import React from 'react';
import { conditionTypeSettingsToSelectOptions } from "../../common/UICustomerFilter";
import DatePickerAttributeFilterField from "./DatePickerAttributeFilterField";
import {
    Select,
    Stack,
    Autocomplete,
    Button,
    ButtonGroup,
    TextField
} from '@shopify/polaris';

class AttributeFilterComponent extends React.Component {

    render() {

        var options = conditionTypeSettingsToSelectOptions(
            this.props.attributeType,
            this.props.attributeIsOptional);

        const shouldDisplayOperator = this.props.attributeType !== "Boolean";

        return (
            <Stack alignment="center" spacing="tight">
                {shouldDisplayOperator && <Select
                    options={options}
                    value={this.props.conditionOperator}
                    onChange={(selected) => this.props.onConditionOperatorChange(selected)}
                />
                }
                {this.createValueInput()}
            </Stack>
        );
    }

    updateSelection = (selected) => {
        if (selected.length === 0) {
            this.props.onConditionValueChange(null);
        }
        else {
            this.props.onConditionValueChange(selected[0]);
        }
    }

    getMatchingOptions = (value) => {

        let newMatchingValueOptions = this.props.distinctValues.map(_ => this.distinctToOption(_));

        if (value !== '' && value != null) {

            const filterRegex = new RegExp(value, 'i');
            newMatchingValueOptions = this.props.distinctValues.filter((option) =>
                option != null && option.match(filterRegex),
            ).map(_ => this.distinctToOption(_));
        }

        return newMatchingValueOptions;
    };

    distinctToOption = (distinctValue) => {

        return {
            "value": distinctValue,
            "label": distinctValue
        }
    }

    createValueInput() {

        if (this.props.conditionOperator === "HasValue" || this.props.conditionOperator === "HasNoValue") {
            return null;
        }

        if (this.props.allowedValues != null) {

            let finalAllowedValues = [
                { label: "--- Choose value ---", value: null },
                ...this.props.allowedValues,
            ];

            return <Select
                options={finalAllowedValues}
                value={this.props.conditionValue}
                onChange={this.props.onConditionValueChange}
            />
        }

        if (this.props.attributeType === "Boolean") {
            return <ButtonGroup segmented>
                <Button pressed={this.props.conditionValue === true} onClick={() => this.props.onConditionValueChange(true)}>Yes</Button>
                <Button pressed={this.props.conditionValue === false} onClick={() => this.props.onConditionValueChange(false)}>No</Button>
            </ButtonGroup>
        }

        if (this.props.conditionType === "Comparable" && this.props.attributeType === "DateTimeOffset") {
            return <DatePickerAttributeFilterField
                conditionValue={this.props.conditionValue}
                onConditionValueChange={this.props.onConditionValueChange}
            />
        }

        if (this.props.conditionType === "DateOffset") {
            return <TextField
                placeholder="Enter amount of hours"
                type="number"
                inputMode="decimal"
                suffix="hours ago"

                value={this.props.conditionValue}
                onChange={(newValue) => this.props.onConditionValueChange(newValue)}
            />
        }

        var textField = (
            <Autocomplete.TextField
                onChange={this.props.onConditionValueChange}
                value={this.props.conditionValue}
                placeholder="Choose value"
            />
        );

        let conditionValue = this.props.conditionValue;
        if (conditionValue != null) {
            conditionValue = conditionValue.toString();
        }

        if (this.props.attributeType === "int") {
            textField = (
                <Autocomplete.TextField
                    onChange={this.props.onConditionValueChange}
                    value={conditionValue}
                    type="number"
                    placeholder="Choose value"
                />
            );
        }

        const matchingOptions = this.getMatchingOptions(this.props.conditionValue);

        return <Autocomplete
            options={matchingOptions}
            selected={[]}
            onSelect={this.updateSelection}
            loading={this.props.isLoading}
            textField={textField}
        />
    }
}

AttributeFilterComponent.defaultProps = {
    distinctValues: []
}

export default AttributeFilterComponent;